import { useRef } from "react";
import { v4 as uuidv4 } from "uuid";

const randomId = () => {
  return process.env.STORYBOOK === "true" || process.env.NODE_ENV === "test"
    ? "test"
    : uuidv4();
};

export const useUuid = (defaultValue?: string) => {
  return useRef<string>(defaultValue || randomId()).current;
};
